const ENDPOINT = "https://siliconmindstechnologies.com/"
export default ENDPOINT